import dayjs from 'dayjs'
const today = new Date()

export const PAGE_DATA = {
  validAge: [16, 120],

  policyValidDates: {
    minDate: today.toLocaleDateString('en-us'),
    maxDate: dayjs(today).add(1, 'month').format('MM/DD/YYYY')
  },

  financers: [
    {
      label: '1st for Women',
      name: '1st for Women',
      value: '1st for Women'
    },
    {
      label: 'AAMI',
      name: 'AAMI',
      value: 'AAMI'
    },
    {
      label: 'AHM',
      name: 'AHM',
      value: 'AHM'
    },
    {
      label: 'ANZ',
      name: 'ANZ',
      value: 'ANZ'
    },
    {
      label: 'APIA',
      name: 'APIA',
      value: 'APIA'
    },
    {
      label: 'Allianz',
      name: 'Allianz',
      value: 'Allianz'
    },
    {
      label: 'Australia Post',
      name: 'Australia Post',
      value: 'Australia Post'
    },
    {
      label: 'Australian Seniors',
      name: 'Australian Seniors',
      value: 'Australian Seniors'
    },
    {
      label: 'Bank of Queensland',
      name: 'Bank of Queensland',
      value: 'Bank of Queensland'
    },
    {
      label: 'Bingle',
      name: 'Bingle',
      value: 'Bingle'
    },
    {
      label: 'Budget Direct',
      name: 'Budget Direct',
      value: 'Budget Direct'
    },
    {
      label: 'Bupa',
      name: 'Bupa',
      value: 'Bupa'
    },
    {
      label: 'CGU',
      name: 'CGU',
      value: 'CGU'
    },
    {
      label: 'Carpeesh',
      name: 'Carpeesh',
      value: 'Carpeesh'
    },
    {
      label: 'Coles',
      name: 'Coles',
      value: 'Coles'
    },
    {
      label: 'Commonwealth Bank',
      name: 'Commonwealth Bank',
      value: 'Commonwealth Bank'
    },
    {
      label: 'GIO',
      name: 'GIO',
      value: 'GIO'
    },
    {
      label: 'Huddle',
      name: 'Huddle',
      value: 'Huddle'
    },
    {
      label: 'ING',
      name: 'ING',
      value: 'ING'
    },
    {
      label: 'Koba',
      name: 'Koba',
      value: 'Koba'
    },
    {
      label: 'NAB',
      name: 'NAB',
      value: 'NAB'
    },
    {
      label: 'NRMA',
      name: 'NRMA',
      value: 'NRMA'
    },
    {
      label: 'Ozicare',
      name: 'Ozicare',
      value: 'Ozicare'
    },
    {
      label: 'PD',
      name: 'PD',
      value: 'PD'
    },
    {
      label: 'QBE',
      name: 'QBE',
      value: 'QBE'
    },
    {
      label: 'Qantas',
      name: 'Qantas',
      value: 'Qantas'
    },
    {
      label: 'RACQ',
      name: 'RACQ',
      value: 'RACQ'
    },
    {
      label: 'RACV',
      name: 'RACV',
      value: 'RACV'
    },
    {
      label: 'Real Insurance',
      name: 'Real Insurance',
      value: 'Real Insurance'
    },
    {
      label: 'Retirease',
      name: 'Retirease',
      value: 'Retirease'
    },
    {
      label: 'Rollin',
      name: 'Rollin',
      value: 'Rollin'
    },
    {
      label: 'Shannons',
      name: 'Shannons',
      value: 'Shannons'
    },
    {
      label: 'Stella',
      name: 'Stella',
      value: 'Stella'
    },
    {
      label: 'Suncorp',
      name: 'Suncorp',
      value: 'Suncorp'
    },
    {
      label: 'Virgin Money',
      name: 'Virgin Money',
      value: 'Virgin Money'
    },
    {
      label: 'Westpac',
      name: 'Westpac',
      value: 'Westpac'
    },
    {
      label: 'Woolworth Insurance',
      name: 'Woolworth Insurance',
      value: 'Woolworth Insurance'
    },
    {
      label: 'Youi',
      name: 'Youi',
      value: 'Youi'
    },
    {
      label: 'Other/Not Listed',
      name: 'Other/Not Listed',
      value: 'Other/Not Listed'
    },
    {
      label: 'Unknown',
      name: 'Unknown',
      value: 'Unknown'
    }
  ],

  gender: [
    {
      label: 'Male',
      value: 'male',
      name: 'male'
    },
    {
      label: 'Female',
      value: 'female',
      name: 'female'
    }
  ],

  licenseType: [
    {
      label: 'Full',
      value: 'full',
      name: 'full'
    },
    {
      label: 'Provisional 2',
      value: 'p2',
      name: 'p2'
    },
    {
      label: 'Provisional 1',
      value: 'p1',
      name: 'p1'
    },
    {
      label: 'Learner',
      value: 'learner',
      name: 'learner'
    },
    {
      label: 'International',
      value: 'international',
      name: 'international'
    }
  ],

  employmentStatus: [
    {
      label: 'Full Time Employment',
      value: 'fulltime',
      name: 'fulltime'
    },
    {
      label: 'Part Time Employment',
      value: 'parttime',
      name: 'parttime'
    },
    {
      label: 'Self Employed',
      value: 'self_employed',
      name: 'self_employed'
    },
    {
      label: 'Retired',
      value: 'retired',
      name: 'retired'
    },
    {
      label: 'Student',
      value: 'student',
      name: 'student'
    },
    {
      label: 'Unemployed',
      value: 'unemployed',
      name: 'unemployed'
    },
    {
      label: 'Home Duties',
      value: 'home_duties',
      name: 'home_duties'
    }
  ],

  reasons: [
    'I\'m looking for a cheaper policy',
    'I\'m looking for a more comprehensive cover',
    'My insurance policy is coming up for renewal',
    'I want to change providers',
    'Just looking'
  ],

  levelOfCover: [
    {
      label: 'Comprehensive',
      value: 'comprehensive',
      name: 'comprehensive',
      info: {
        title: 'Comprehensive',
        content: 'Comprehensive Insurance covers accidental loss or damage to your car, including car accidents, theft, fire and natural events like hail and flood. It also provides cover for accidental damage caused to other people\'s property if the driver of your car is at fault.'
      }
    },
    {
      label: 'Third Party Fire & Theft',
      value: 'third_party_fire_theft',
      name: 'third_party_fire_theft',
      info: {
        title: 'Third Party Fire & Theft',
        content: 'Third party property, fire and theft Insurance covers loss or damage to your vehicle by fire, attempted theft and theft only, and your legal liability for loss or damage to another person\'s vehicle or property.'
      }
    },
    {
      label: 'Third Party Property Damage',
      value: 'third_party_property',
      name: 'third_party_property',
      info: {
        title: 'Third Party Property Damage',
        content: 'Third party property damage covers your legal liability for accidental loss or damage to another person\'s property.'
      }
    },
    {
      label: 'CTP / Greenslip',
      value: 'ctp_greenslip',
      name: 'ctp_greenslip',
      disabled: true
    }
  ],

  rego: [
    {
      label: 'I don\'t know',
      value: 'idk',
      name: 'idk'
    },
    {
      label: 'Not Registered',
      value: 'not_registered',
      name: 'not_registered'
    }
  ],

  stateOptions: [
    {
      label: 'ACT',
      name: 'act',
      value: 'act'
    },
    {
      label: 'NSW',
      name: 'nsw',
      value: 'nsw'
    },
    {
      label: 'NT',
      name: 'nt',
      value: 'nt'
    },
    {
      label: 'QLD',
      name: 'qld',
      value: 'qld'
    },
    {
      label: 'SA',
      name: 'sa',
      value: 'sa'
    },
    {
      label: 'TAS',
      name: 'tas',
      value: 'tas'
    },
    {
      label: 'VIC',
      name: 'vic',
      value: 'vic'
    },
    {
      label: 'WA',
      name: 'wa',
      value: 'wa'
    }
  ],

  transmission: [
    {
      label: 'Automatic',
      value: 'auto'
    },
    {
      label: 'Manual',
      value: 'Manual'
    },
    {
      label: 'Unsure',
      value: 'unsure'
    }
  ],

  colours: [
    {
      label: 'Beige',
      name: 'Beige',
      value: 'Beige'
    },
    {
      label: 'Black',
      name: 'Black',
      value: 'Black'
    },
    {
      label: 'Blue',
      name: 'Blue',
      value: 'Blue'
    },
    {
      label: 'Brown',
      name: 'Brown',
      value: 'Brown'
    },
    {
      label: 'Gold',
      name: 'Gold',
      value: 'Gold'
    },
    {
      label: 'Green',
      name: 'Green',
      value: 'Green'
    },
    {
      label: 'Grey',
      name: 'Grey',
      value: 'Grey'
    },
    {
      label: 'Maroon',
      name: 'Maroon',
      value: 'Maroon'
    },
    {
      label: 'Orange',
      name: 'Orange',
      value: 'Orange'
    },
    {
      label: 'Purple',
      name: 'Purple',
      value: 'Purple'
    },
    {
      label: 'Red',
      name: 'Red',
      value: 'Red'
    },
    {
      label: 'Silver',
      name: 'Silver',
      value: 'Silver'
    },
    {
      label: 'Turquoise',
      name: 'Turquoise',
      value: 'Turquoise'
    },
    {
      label: 'White',
      name: 'White',
      value: 'White'
    },
    {
      label: 'Yellow',
      name: 'Yellow',
      value: 'Yellow'
    },
    {
      label: 'Other',
      name: 'Other',
      value: 'Other'
    }
  ],

  policyLogos: {
    abarth: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ABARTH.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    alfaRomeo: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ALFA ROMEO.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    alpine: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ALPINE.png',
      dimensions: {
        width: 48,
        height: 30
      }
    },
    astonMartin: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ASTON MARTIN.png',
      dimensions: {
        width: 48,
        height: 24
      }
    },
    audi: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/AUDI.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    bentley: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/BENTLEY.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    bmwAlpina: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/BMW ALPINA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    bmw: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/BMW.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    caterham: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/CATERHAM.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    chevrolet: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/CHEVROLET.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    chrysler: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/CHRYSLER.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    citroen: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/CITROEN.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    daf: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/daf-logo.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    ferrari: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/FERRARI.png',
      dimensions: {
        width: 48,
        height: 70
      }
    },
    fiat: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/FIAT.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    ford: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/FORD.png',
      dimensions: {
        width: 48,
        height: 19
      }
    },
    genesis: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/GENESIS.png',
      dimensions: {
        width: 48,
        height: 19
      }
    },
    gwm: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/GWM.png',
      dimensions: {
        width: 48,
        height: 39
      }
    },
    haval: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/HAVAL.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    honda: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/HONDA.png',
      dimensions: {
        width: 48,
        height: 33
      }
    },
    hyundai: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/HYUNDAI.png',
      dimensions: {
        width: 48,
        height: 26
      }
    },
    isuzu: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ISUZU.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    iveco: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/IVECO.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    jaguar: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/JAGUA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    jeep: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/JEEP.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    kia: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/KIA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    lamborghini: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/LAMBORGHINI.png',
      dimensions: {
        width: 48,
        height: 53
      }
    },
    landRover: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/LAND ROVER.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    ldv: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/LDV.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    lexus: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/LEXUS.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    lotus: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/LOTUS.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    mahindra: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MAHINDRA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    maserati: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MASERATI.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mazda: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MAZDA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mclaren: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/McLAREN.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mercedesAmg: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MERCEDES-AMG.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mercedesBenz: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MERCEDES-BENZ.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mercedesMaybach: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MERCEDES-MAYBACH.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mg: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MG.png',
      dimensions: {
        width: 48,
        height: 36
      }
    },
    mini: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MINI.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    mitsubishiFuso: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MITSUBISHI FUSO.png',
      dimensions: {
        width: 48,
        height: 60
      }
    },
    mitsubishi: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MITSUBISHI.png',
      dimensions: {
        width: 48,
        height: 60
      }
    },
    morgan: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/MORGAN.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    nissan: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/NISSAN.png',
      dimensions: {
        width: 48,
        height: 39
      }
    },
    peugeot: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/PEUGEOT.png',
      dimensions: {
        width: 48,
        height: 32
      }
    },
    porsche: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/PORSCHE.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    ram: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/RAM.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    renault: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/RENAULT.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    rollsRoyce: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/ROLLS-ROYCE.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    skoda: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/SKODA.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    ssangYong: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/SSANGYONG.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    subaru: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/SUBARU.png',
      dimensions: {
        width: 48,
        height: 27
      }
    },
    suzuki: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/SUZUKI.png',
      dimensions: {
        width: 48,
        height: 24
      }
    },
    tesla: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/TESLA.png',
      dimensions: {
        width: 48,
        height: 61
      }
    },
    toyota: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/TOYOTA.png',
      dimensions: {
        width: 48,
        height: 40
      }
    },
    volkswagen: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/VOLKSWAGEN.png',
      dimensions: {
        width: 48,
        height: 48
      }
    },
    volvo: {
      url: 'https://asset.compareclub.com.au/car-insurance/car-logos/VOLVO.png',
      dimensions: {
        width: 48,
        height: 27
      }
    }
  },

  accidentOrRepair: [
    {
      label: 'No Damage ',
      value: 'no_damage',
      name: 'no_damage'
    },
    {
      label: 'Hail Damage',
      value: 'hail_damage',
      name: 'hail_damage'
    },
    {
      label: 'Accident Damage',
      value: 'accident_damage',
      name: 'accident_damage'
    },
    {
      label: 'Accident and Hail Damage',
      value: 'accident_and_hail_damage',
      name: 'accident_and_hail_damage'
    },
    {
      label: 'Rust',
      value: 'rust',
      name: 'rust'
    }
  ],

  currentFinance: [
    {
      label: 'No',
      value: 'No',
      name: 'No'
    },
    {
      label: 'Yes (Finance/Hire Purchase)',
      value: 'finance_hire_purchase',
      name: 'finance_hire_purchase'
    },
    {
      label: 'Yes (Lease/Novated Lease)',
      value: 'lease_novated_lease',
      name: 'lease_novated_lease'
    }
  ],

  carUse: [
    {
      label: 'Private and/or commuting to work',
      value: 'private_commuting_work',
      name: 'private_commuting_work',
      info: {
        title: 'Private and/or Commuting only',
        content: 'Is used for social, domestic and pleasure purposes;  e.g. travelling to and from work.'
      }
    },
    {
      label: 'Private and occasional business',
      value: 'private_occasional_business',
      name: 'private_occasional_business',
      info: {
        title: 'Private and Occasional Business',
        content: 'Is used for social, domestic and pleasure purposes, travelling to and from work, as well as occasional business use. Occasional business means the car is not registered for business use and does not form an essential part in earning income from such business.'
      }
    },
    {
      label: 'Private and business',
      value: 'private_business',
      name: 'private_business',
      info: {
        title: 'Private and Business',
        content: 'Is used for social, domestic and pleasure purposes, travelling to and from work, as well as business use. Business use means either the car is registered for business or is used in conjunction with a business or occupation.'
      }
    },
    {
      label: 'Business',
      value: 'business',
      name: 'business',
      info: {
        title: 'Business only',
        content: 'Is used for business. Business use means either the car is registered for business or is used in conjunction with a business or occupation.'
      }
    }
  ],

  yesno: [
    'Yes',
    'No'
  ],

  carUseFuture: [
    {
      label: 'Carrying passengers for payment (includes taxis and / or ridesharing)',
      value: 'carrying_passengers_for_payment',
      name: 'carrying_passengers_for_payment'
    },
    {
      label: 'Providing paid driving tuition',
      value: 'providing_paid_driving_tuition',
      name: 'providing_paid_driving_tuition'
    },
    {
      label: 'Hiring out to other people for payment',
      value: 'hiring_out_to_other_people_for_payment',
      name: 'hiring_out_to_other_people_for_payment'
    },
    {
      label: 'Courier or delivery goods',
      value: 'courier_or_delivery_goods',
      name: 'courier_or_delivery_goods'
    },
    {
      label: 'Courtesy or hire car',
      value: 'courtesy_or_hire_car',
      name: 'courtesy_or_hire_car'
    },
    {
      label: 'Emergency services',
      value: 'emergency_services',
      name: 'emergency_services'
    },
    {
      label: 'None of these',
      value: 'none_of_these',
      name: 'none_of_these'
    }
  ],

  nonStandardAccessories: [
    'After Market Alarm',
    'Air Compressor',
    'Air Conditioner',
    'Airbag',
    'Alloy Standard Size',
    'Amplifier',
    'Awning',
    'Bluetooth',
    'Bonnet Protector',
    'Bonnet Scoop',
    'Boot Speakers',
    'Brakes Anti Lock',
    'Bull Bar',
    'Camper Added',
    'Canopy',
    'Cargo Barrier',
    'CB Radio',
    'CD Player/Stacker',
    'Central Locking',
    'Child Seats',
    'Cruise Control',
    'Dash Cam',
    'Dual Batteries',
    'Dual Fuel Tanks',
    'Dual Fuel/LPG Conversion',
    'DVD Player',
    'Electric Mirrors',
    'Fabric Protection',
    'Fog/Driving Lights',
    'Free Wheel Hubs',
    'Front Spoiler/Dam',
    'GPS (Satellite Navigation)',
    'Graphic Equaliser',
    'Grills',
    'Headlight Protector',
    'Immobiliser',
    'Ladder Racks',
    'Leather Interior',
    'Locking Nuts',
    'Long Range Tank',
    'Mobile Phone Kit',
    'Mud Flaps',
    'Non Standard Alloy Wheels',
    'Nudge Bar',
    'Nudge Bar Rear',
    'Paint Protection',
    'Paint Signwriting',
    'Pedals',
    'Plastic Cover',
    'Plastic Shield',
    'Power Windows',
    'Radio Cassette',
    'Rear Lamp',
    'Rear SpoilerAerofoil',
    'Reversing Sensors/Camera',
    'Roll Bar',
    'Roof Rack',
    'Rust Protection',
    'Seat Covers',
    'Seats - Additional',
    'Shelving/Storage',
    'Side Steps/Running Boards',
    'Snorkel',
    'Spare Wheel Cover',
    'Sports Steering Wheel',
    'Step Up',
    'Stereo/Entertainment System',
    'Sunroof',
    'Television',
    'Tonneau Cover',
    'Tow Bar',
    'Tray Top',
    'Ute Liner',
    'Weather Shield',
    'Wheel Arch Flares',
    'Winch',
    'Window Louvre/Shade',
    'Window Tint'
  ],

  carPark: [
    {
      label: 'Carport',
      value: 'carport',
      name: 'carport'
    },
    {
      label: 'Carpark',
      value: 'carpark',
      name: 'carpark'
    },
    {
      label: 'Driveway',
      value: 'driveway',
      name: 'driveway'
    },
    {
      label: 'Garage',
      value: 'garage',
      name: 'garage'
    },
    {
      label: 'Locked Compound',
      value: 'locked_compound',
      name: 'locked_compound'
    },
    {
      label: 'Street',
      value: 'street',
      name: 'street'
    }
  ],

  residentialStatus: [
    'Owner',
    'Renter',
    'Other'
  ],

  comprehensiveInsurance: [
    {
      label: 'No',
      value: 'No',
      name: 'no'
    },
    {
      label: 'Yes and I\'ve been with my current insurer for 1 year',
      value: 'Yes',
      name: 'yes'
    },
    {
      label: 'Yes and I\'ve been with my current insurer for 2 years',
      value: '2',
      name: '2_years'
    },
    {
      label: 'Yes and I\'ve been with my current insurer for 3 years',
      value: '3',
      name: '3_years'
    },
    {
      label: 'Yes and I\'ve been with my current insurer for 4 years',
      value: '4',
      name: '4_years'
    },
    {
      label: 'Yes and I\'ve been with my current insurer for 5+ years',
      value: '5+',
      name: '5_plus_years'
    }
  ],

  claims: [
    {
      label: '0',
      value: '0',
      name: '0'
    },
    {
      label: '1',
      value: '1',
      name: '1'
    },
    {
      label: '2',
      value: '2',
      name: '2'
    },
    {
      label: '3',
      value: '3',
      name: '3'
    },
    {
      label: '4',
      value: '4',
      name: '4'
    },
    {
      label: '5 or more',
      value: '5 or more',
      name: '5_or_more'
    },
    {
      label: 'I\'m unsure',
      value: 'I\'m unsure',
      name: 'unsure'
    }
  ],

  noClaimDiscount: [
    {
      label: '1 (5+ Years No Claim Discount)',
      value: '1',
      name: '1'
    },
    {
      label: '2 (4+ Years No Claim Discount)',
      value: '2',
      name: '2'
    },
    {
      label: '3 (3+ Years No Claim Discount)',
      value: '3',
      name: '3'
    },
    {
      label: '4 (2+ Years No Claim Discount)',
      value: '4',
      name: '4'
    },
    {
      label: '5 (1+ Years No Claim Discount)',
      value: '5',
      name: '5'
    },
    {
      label: '6 (None)',
      value: '6 (None)',
      name: '6 (None)'
    },
    {
      label: 'Don\'t know',
      value: 'Don\'t know',
      name: 'Don\'t know'
    }
  ],

  timeLiving: [
    {
      label: 'Less than 1 Year',
      value: '0',
      name: '0'
    },
    {
      label: '1',
      value: '1',
      name: '1'
    },
    {
      label: '2',
      value: '2',
      name: '2'
    },
    {
      label: '3',
      value: '3',
      name: '3'
    },
    {
      label: '4',
      value: '4',
      name: '4'
    },
    {
      label: '5 more years',
      value: '5',
      name: '5'
    }
  ],

  ageRestriction: [
    {
      label: 'No restrictions',
      value: 'No restrictions',
      name: 'no_restriction'
    },
    {
      label: '21+',
      value: '21+',
      name: '21_plus'
    },
    {
      label: '25+',
      value: '25+',
      name: '25_plus'
    },
    {
      label: '30+',
      value: '30+',
      name: '30_plus'
    },
    {
      label: '40+',
      value: '40+',
      name: '40_plus'
    },
    {
      label: '50+',
      value: '50+',
      name: '50_plus'
    }
  ],

  excessData: [
    {
      label: '$500',
      value: '500',
      name: '500'
    },
    {
      label: '$600',
      value: '600',
      name: '600'
    },
    {
      label: '$700',
      value: '700',
      name: '700'
    },
    {
      label: '$800',
      value: '800',
      name: '800'
    },
    {
      label: '$900',
      value: '900',
      name: '900'
    },
    {
      label: '$1000',
      value: '1000',
      name: '1000'
    },
    {
      label: '$1100',
      value: '1100',
      name: '1100'
    },
    {
      label: '$1200',
      value: '1200',
      name: '1200'
    },
    {
      label: '$1300',
      value: '1300',
      name: '1300'
    },
    {
      label: '$1400',
      value: '1400',
      name: '1400'
    },
    {
      label: '$1500',
      value: '1500',
      name: '1500'
    },
    {
      label: '$1600',
      value: '1600',
      name: '1600'
    },
    {
      label: '$1700',
      value: '1700',
      name: '1700'
    },
    {
      label: '$1800',
      value: '1800',
      name: '1800'
    },
    {
      label: '$1900',
      value: '1900',
      name: '1900'
    },
    {
      label: '$2000',
      value: '2000',
      name: '2000'
    }
  ],

  paymentFrequencyData: [
    {
      label: 'Annually',
      value: 'annually',
      name: 'annually'
    },
    {
      label: 'Monthly',
      value: 'monthly',
      name: 'monthly'
    }
  ],

  quickTips: [
    'Get quotes for <strong>free</strong>',
    '<strong>Within minutes,</strong> see how your renewal compares',
    '<strong>No hidden fees</strong> - quote premiums direct from the insurer'
  ]

}

export const ERROR_MAP = {
  // registration
  looking_for: 'Please select one of the options below',
  type_of_cover: 'Please select one of the options below',
  state: 'Please select one of the options below',
  rego: 'Please enter your rego',
  vehicle_purchased: 'Please enter the year vehicle purchased',
  rego_type: '',

  // search
  vehicle_year: 'Please select one of the options below',
  vehicle_make: 'Please select one of the options below',
  vehicle_model: 'Please select one of the options below',
  vehicle_variant: 'Please select one of the options below',
  vehicle_series: 'Please select one of the options below',
  vehicle_colour: 'Please select one of the options below',
  vehicle_transmission: 'Please select one of the options below',

  // car-details
  factory_options: 'Please select one of the options below',
  accessories: 'Please select one of the options below',
  modified: 'Please select one of the options below',

  // options
  factory_fitted_dealer_options: 'Please select options below',

  // accessories
  non_standard_accessories: 'Please select options below',

  // about
  repairs: 'Please select one of the options below',
  current_finance: 'Please select one of the options below',
  car_use: 'Please select one of the options below',
  car_use_future: 'Please select one of the options below',
  kms: 'Please enter your average kilometers',
  car_park: 'Please select one of the options below',
  residential_address: 'Please input correct address',
  residential_status: 'Please select one of the options below',
  time_living: 'Please select one of the options below',
  financer: 'Please enter your financier name or select the option',

  // drivers
  main_date_of_birth: 'Please enter your valid date of birth',
  main_gender: 'Please select one of the options below',
  main_license_type: 'Please select one of the options below',
  main_age: 'Please enter your licence receiving age',
  main_employment_status: 'Please select one of the options below',
  another_car: 'Please select one of the options below',
  another_driver: 'Please select one of the options below',
  second_date_of_birth: 'Please enter your valid date of birth',
  second_gender: 'Please select one of the options below',
  second_age: 'Please enter your licence receiving age',

  // coverage
  had_insurance: 'Please select one of the options below',
  how_many_claims: 'Please select one of the options below',
  no_claim_discount: 'Please select one of the options below',

  // coverage-details
  current_provider: 'Please select one of the options below',
  current_policy_expired: 'Please enter policy expire date',
  increase_age_restriction: 'Please select one of the options below',
  policy_start: 'Please enter policy start date.'
}

export const SUMMARY_MAP = {
  car: {
    label: '',
    icon: '',
    origin: 'car-details'
  },
  factory_fitted_dealer_options: {
    label: '',
    icon: '',
    origin: 'car-details'
  },
  non_standard_accessories: {
    label: '',
    icon: '',
    origin: 'car-details'
  },
  modified: {
    label: 'Modified',
    icon: '',
    origin: 'car-details'
  },
  repairs: {
    label: '',
    icon: 'icons/car.svg',
    origin: 'about'
  },
  current_finance: {
    label: 'Finance',
    icon: 'icons/coin.svg',
    origin: 'about'
  },
  car_use: {
    label: '',
    icon: 'icons/car-forward.svg',
    origin: 'about'
  },
  driver_details: {
    label: '',
    icon: '',
    origin: 'drivers'
  },
  main_license_type: {
    label: 'License',
    icon: '',
    origin: 'drivers'
  },
  another_driver: {
    label: 'Additional Drivers',
    icon: '',
    origin: 'drivers'
  },
  how_many_claims: {
    label: 'Claims',
    icon: 'icons/file.svg',
    origin: 'coverage'
  }
}

export const FORM_STEPS = [
  'Start',
  'Vehicles',
  'Drivers',
  'Coverage',
  'Result'
]

export const FORM_HEADER = {
  registration: {
    pageTitle: 'Step 1: Getting Started',
    tag: 'FREE!',
    title: 'Take a few minutes to answer some questions for a personalised quote from our partner <strong>PD Insurance</strong>',
    component: 'div'
  },

  vehicle: {
    pageTitle: 'Step 2: Vehicle Information',
    title: 'Tell us about <strong>your car</strong>',
    component: 'AtomsHeadline'
  },

  search: {
    pageTitle: 'Step 2: Manual Car Selection',
    title: 'Tell us about <strong>your car</strong>',
    component: 'AtomsHeadline'
  },

  'car-details': {
    pageTitle: 'Step 3: Car Options',
    title: 'Tell us about <strong>your car</strong>',
    component: 'AtomsHeadline'
  },

  options: {
    pageTitle: 'Step 4a: Car Factory Options',
    title: 'Tell us about the <strong>factory or dealer fitted options on the car</strong>',
    component: 'AtomsHeadline'
  },

  accessories: {
    pageTitle: 'Step 4b: Car Non Standard Accessories',
    title: 'Tell us about <strong>your car accessories</strong>',
    component: 'AtomsHeadline'
  },

  about: {
    pageTitle: 'Step 5: Car Condition and LocationForm',
    title: 'About <strong>the car</strong>',
    component: 'AtomsHeadline'
  },

  drivers: {
    pageTitle: 'Step 6: Drivers',
    title: 'Next, let\'s <strong>add your drivers</strong>',
    component: 'AtomsHeadline'
  },

  coverage: {
    pageTitle: 'Step 7: Coverage',
    title: 'We now need to collect some <strong>insurance </strong> and <strong> claims information</strong>',
    component: 'AtomsHeadline'
  },

  'coverage-details': {
    pageTitle: 'Step 8: Start Date and Discounts',
    title: 'Your <strong>Coverage </strong>',
    component: 'AtomsHeadline'
  }
}

export const FORM_QUESTIONS = {
  lookingFor: {
    question: 'Hi, what brought you here today?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'reason',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.reasons
        }
      }
    ]
  },

  typeOfCover: {
    question: 'What level of cover are you looking for?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'typeOfCover',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.levelOfCover,
          infoShowAction: 'hover'
        }
      }
    ]
  },

  rego: {
    question: 'What is your car registration?',
    components: [
      {
        component: 'AtomsInput',
        props: {
          name: 'rego',
          placeholder: 'Please input rego',
          label: 'Rego',
          theme: 'light'
        }
      },
      {
        component: 'MoleculesSelection',
        props: {
          name: 'regoType',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.rego
        }
      }
    ]
  },

  vehiclePurchased: {
    question: 'Year vehicle was purchased',
    components: [
      {
        component: 'AtomsInput',
        props: {
          name: 'vehiclePurchased',
          placeholder: 'Please input year vehicle',
          label: 'Vehicle purchased year',
          maxlength: '4',
          theme: 'light'
        }
      }
    ]
  },

  state: {
    question: 'State',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Please select your state',
          label: 'State',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'state',
          dataArr: PAGE_DATA.stateOptions,
          errorMessage: 'Please select your state',
          theme: 'light'
        }
      }
    ]
  },

  vehicleYear: {
    question: 'Vehicle Year',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_year',
          label: 'Vehicle year',
          placeholder: 'Please input year between 1961 - 2022',
          dataListLimit: 30,
          options: [],
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleMake: {
    question: 'Vehicle Make',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_make',
          label: 'Vehicle make',
          placeholder: 'Please input vehicle make',
          dataArr: [],
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleModel: {
    question: 'Vehicle Model',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_model',
          label: 'Vehicle model',
          placeholder: 'Please input vehicle model',
          dataArr: [],
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleVariant: {
    question: 'Vehicle Variant',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_variant',
          label: 'Vehicle variant',
          placeholder: 'Please input vehicle variant',
          dataArr: [],
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleSeries: {
    question: 'Vehicle Series',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_series',
          label: 'Vehicle series',
          placeholder: 'Please input vehicle series',
          dataArr: [],
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleColour: {
    question: 'Vehicle Colour',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'vehicle_colour',
          label: 'Vehicle colour',
          placeholder: 'Please input vehicle colour',
          dataArr: PAGE_DATA.colours,
          dataValue: 'value',
          searchable: true,
          theme: 'light'
        }
      }
    ]
  },

  vehicleTransmission: {
    question: 'Vehicle Transmission',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'vehicle_transmission',
          label: 'Vehicle transmission',
          type: 'radio',
          ticker: 'circle',
          placeholder: 'Select vehicle transmission',
          options: PAGE_DATA.transmission
        }
      }
    ]
  },

  factoryOptions: {
    question: 'Do you have any factory or dealer fitted options with the car?',
    desc: 'Factory/dealer options are items which were fitted to the car as an option by the manufacturer or dealer when the car was first purchased (for example, tinted windows).',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'factory_options',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.yesno,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  accessories: {
    question: 'Do you have any non standard accessories fitted to the car?',
    desc: 'These are the other accessories that have been fitted to the car after it left the manufacturer, such as a tow bar, roof rack, child seat, etc.',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'accessories',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.yesno,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  modified: {
    question: 'Have you modified the car?',
    desc: 'A modification refers to any alteration to the car\'s standard engine, exhaust system, body, suspension, wheels or paintwork. <br /><br />Please note: You may need to provide further detail to the insurer before they can finalise your quote. Also, this may make you ineligible for insurance with certain insurers.',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'modified',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  factoryFittedDealerOptions: {
    question: 'What are the factory or dealer fitted options?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          type: 'checkbox',
          options: [],
          inline: true
        }
      }
    ]
  },

  nonStandardAccessories: {
    question: 'What are the non standard accessories?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          type: 'checkbox',
          options: PAGE_DATA.nonStandardAccessories,
          inline: true
        }
      }
    ]
  },

  repairs: {
    question: 'Does your car have any unrepaired accident, hail or rust damage?',
    desc: 'Is there existing unrepaired damage to your car (eg. Panel damage, hail damage or rust)?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'repairs',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.accidentOrRepair
        }
      }
    ]
  },

  currentFinance: {
    question: 'Is there currently finance on the car?',
    desc: 'Insurers may use this information to understand who has a financial interest in the car.',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'current_finance',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.currentFinance
        }
      }
    ]
  },

  financer: {
    question: 'What is the name of the financier or interested party to appear on your certificate of currency?',
    components: [
      {
        component: 'AtomsInput',
        props: {
          name: 'financer',
          placeholder: 'Financier or interested party',
          label: '',
          theme: 'light'
        }
      },
      {
        component: 'MoleculesSelection',
        props: {
          name: 'certificate',
          type: 'radio',
          ticker: 'circle',
          options: [
            {
              label: 'I don\'t need a certificate',
              value: 'none',
              name: 'none'
            }
          ]
        }
      }
    ]
  },

  carUse: {
    question: 'How do you use the car?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'car_use',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.carUse,
          infoShowAction: 'hover'
        }
      }
    ]
  },

  carUseFuture: {
    question: 'Will the car be used for:',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Select options',
          label: 'Car use',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'car_use_future',
          dataArr: PAGE_DATA.carUseFuture,
          errorMessage: 'Please select an option',
          theme: 'light'
        }
      }
    ]
  },

  kms: {
    question: 'How many kilometres do you drive on average with this car each year?',
    desc: 'With some insurers, you may qualify for a reduced premium if the car\'s yearly km\'s is low.',
    components: [
      {
        component: 'AtomsInput',
        componentDesc: 'Rounded to the neareast 1,000 kms.',
        props: {
          name: 'kms',
          placeholder: 'Enter KMs',
          label: '',
          theme: 'light',
          maxlength: '7',
          modelType: 'number'
        }
      }
    ]
  },

  residentialAddress: {
    question: 'What is the address of where the car is usually parked at night?',
    components: [
      {
        component: 'MoleculesFormAddress',
        props: {
          name: 'residential_address',
          defaultState: ''
        }
      }
    ]
  },

  carPark: {
    question: 'Where is the car usually parked at night?',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Select place',
          label: 'Select place',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'car_park',
          dataArr: PAGE_DATA.carPark,
          theme: 'light'
        }
      }
    ]
  },

  residentialStatus: {
    question: 'What is your current residential status?',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Select status',
          label: 'Select residential status',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'residential_status',
          dataArr: PAGE_DATA.residentialStatus,
          theme: 'light'
        }
      }
    ]
  },

  timeLiving: {
    question: 'Length of time living at current address?',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Select options',
          label: 'Please select length of time living at current address',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'time_living',
          dataArr: PAGE_DATA.timeLiving,
          theme: 'light'
        }
      }
    ]
  },

  mainDateOfBirth: {
    question: 'Date of Birth',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Birthdate (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          theme: 'light',
          disableDatepicker: true
        }
      }
    ]
  },

  mainGender: {
    question: 'Gender',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'main_gender',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.gender,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  mainLicenseType: {
    question: 'What is the main driver’s license type?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'main_license_type',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.licenseType
        }
      }
    ]
  },

  mainAge: {
    question: 'At what age did they receive their licence?',
    desc: 'Please enter the age the main driver obtained their provisional licence. If they got their licence before the age of 16, please enter 16 as the age.',
    components: [
      {
        component: 'AtomsInput',
        props: {
          name: 'main_age',
          placeholder: 'Age',
          modelType: 'number',
          label: '',
          minlength: '1',
          maxlength: '2',
          theme: 'light'
        }
      }
    ]
  },

  mainEmploymentStatus: {
    question: 'What is the main driver\'s employment status?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'main_employment_status',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.employmentStatus
        }
      }
    ]
  },

  anotherCar: {
    question: 'Does the main driver own another car?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'another_car',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.yesno,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  anotherDriver: {
    question: 'Will any driver be younger than the main driver?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'another_driver',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.yesno,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  secondDateOfBirth: {
    question: 'Date of Birth',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Birthdate (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          theme: 'light',
          disableDatepicker: true
        }
      }
    ]
  },

  secondGender: {
    question: 'Gender',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'second_gender',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.gender,
          cols: 2,
          mobileCols: 2
        }
      }
    ]
  },

  secondAge: {
    question: 'At what age did they receive their licence?',
    desc: 'Please enter the age the driver obtained their provisional licence. If they got their licence before the age of 16, please enter 16 as the age.',
    components: [
      {
        component: 'AtomsInput',
        props: {
          name: 'second_age',
          placeholder: 'Age',
          modelType: 'number',
          label: '',
          minlength: '1',
          maxlength: '2',
          theme: 'light'
        }
      }
    ]
  },

  hadInsurance: {
    question: 'Has the main driver held continuous comprehensive insurance over the last 12 months?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'had_insurance',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.comprehensiveInsurance
        }
      }
    ]
  },

  howManyClaims: {
    question: 'How many claims has the main driver had regardless of fault within the last 5 years?',
    desc: 'We need to know about all types of damage and accidents such as collisions, fire, theft, glass, hail or malicious damage; whether you were at fault or not at fault or were driving a different car. <br /><br />You don\'t have to tell us claims that you have withdrawn before they were processed.',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'how_many_claims',
          type: 'radio',
          ticker: 'circle',
          options: PAGE_DATA.claims,
          cols: 2
        }
      }
    ]
  },

  noClaimDiscount: {
    question: 'What is the main driver\'s current no claim discount?',
    desc: 'A No Claims Discount (NCD) or Rating Discount is simply the no claims discount your current insurer offers you as a reward for a good claims history. As an existing Car Insurance policy holder, your NCD may be listed on your renewal notice.',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Select options',
          label: 'Please select main driver\'s current no claim discount',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          name: 'no_claim_discount',
          dataArr: PAGE_DATA.noClaimDiscount,
          theme: 'light'
        }
      }
    ]
  },

  currentProvider: {
    question: 'Who is your current insurance provider?',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'current_provider',
          label: '',
          placeholder: 'Provider',
          options: [],
          dataArr: PAGE_DATA.financers,
          dataValue: 'value',
          theme: 'light'
        }
      }
    ]
  },

  currentPolicyExpired: {
    question: 'Current policy expire date?',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          name: 'policy_start',
          label: 'Please enter expire date',
          placeholder: 'Enter date (dd/mm/yyyy)',
          disableDatepicker: false,
          theme: 'light',
          minDate: PAGE_DATA.policyValidDates.minDate
        }
      }
    ]
  },

  increaseAgeRestriction: {
    question: 'Would you like to increase the age restriction?',
    desc: 'Generally the higher the age restriction the more you will save on your policy however its important to remember that these drivers will not be covered.',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'increase_age_restriction',
          type: 'radio',
          ticker: 'circle',
          options: []
        }
      }
    ]
  },

  policyStart: {
    question: 'When would you like to start the policy?',
    desc: 'Your policy can start from today to up to one month in advance.',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          name: 'policy_start',
          label: 'Please enter start date',
          placeholder: 'Enter date (dd/mm/yyyy)',
          disableDatepicker: false,
          theme: 'light',
          minDate: PAGE_DATA.policyValidDates.minDate,
          maxDate: PAGE_DATA.policyValidDates.maxDate
        }
      }
    ]
  }
}

export const FORM_ITEMS_ARR = {
  registration: [
    'lookingFor',
    'typeOfCover'
  ],
  vehicle: [
    'rego',
    'regoType',
    'vehiclePurchased',
    'state'
  ],
  search: [
    'vehicleYear',
    'vehicleMake',
    'vehicleModel',
    'vehicleVariant',
    'vehicleSeries',
    'vehicleColour',
    'vehicleTransmission'
  ],
  'car-details': [
    'factoryOptions',
    'accessories',
    'modified'
  ],
  options: [
    'factoryFittedDealerOptions'
  ],
  accessories: [
    'nonStandardAccessories'
  ],
  about: [
    'repairs',
    'currentFinance',
    'financer',
    'certificate',
    'carUse',
    'carUseFuture',
    'kms',
    'residentialAddress',
    'carPark',
    'residentialStatus',
    'timeLiving'
  ],
  drivers: [
    'mainDateOfBirth',
    'mainGender',
    'mainLicenseType',
    'mainAge',
    'mainEmploymentStatus',
    'anotherCar',
    'anotherDriver',
    'secondDateOfBirth',
    'secondGender',
    'secondAge'
  ],
  coverage: [
    'hadInsurance',
    'howManyClaims',
    'noClaimDiscount'
  ],
  'coverage-details': [
    'currentProvider',
    'currentPolicyExpired',
    'increaseAgeRestriction',
    'policyStart'
  ]
}

export const COMPARISON_FORM_STEPS = [
  {
    label: 'About You',
    iconComponent: 'IconsIdentityCard',
    iconDimensions: {
      width: 24,
      height: 24
    }
  },
  {
    label: 'Compare',
    iconComponent: 'IconsCompareCard',
    iconDimensions: {
      width: 24,
      height: 24
    }
  },
  {
    label: 'Apply',
    iconComponent: 'IconsApply',
    iconDimensions: {
      width: 24,
      height: 24
    }
  },
  {
    label: 'Submit',
    iconComponent: 'IconsLifeCompleteCard',
    iconDimensions: {
      width: 17,
      height: 20
    }
  }
]
